import React from 'react';
import styled from 'styled-components'
import colors from '../../globals/colors'
import { Loading } from '../molecules/Loading';

export const FixedOverlay = styled.div<{}>`
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1000;
`
const BodyStyles = styled.div`
    background-color: ${colors.lightest};
    margin: 0px;
    padding: 0px;
    width: 100vw;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
`
export const ColumnFlexBox = styled.div`
    display: flex;
    flex-direction: column;
`
export const RowFlexBox = styled.div`
    display: flex;
    flex-direction: row;
`

export const Body: React.FC<{ style?: React.CSSProperties, loading?: boolean, }> = ({ children, loading, style }) => {

    return (
        <div>
            {loading && <Loading />}
            <BodyStyles style={style}>
                {children}
            </BodyStyles>
        </div>

    );
};

export const Container: React.FC = ({ children }) => {
    return (
        <div style={{ textAlign: 'center', justifyContent: 'center', marginLeft: 'auto', marginRight: 'auto', display: 'flex' }}>
            <div style={{ margin: 10, maxWidth: 1200 }}>
                {children}
            </div>
        </div>
    )
}


